// --- src/data/m2/Unit3.js ---

export const M2_UNIT_3 = {
  id: "m2-u3-asking-questions",
  title: "Unit 3: Asking Questions",
  topic: "Wh- Questions (What, Where, When, Who, Why, How)",
  iconType: "question",
  grammarImage: "/m2-u3-questions.jpg",
  grammarText: "Aprende a hacer preguntas abiertas usando What, Where, When, Who, Why, How. Estas palabras van al principio, seguidas del auxiliar (Do/Does/Is/Are).",
  sets: [

    // ===================================================================
    // SET 1: QUESTION WORDS BASICS (A1)
    // ===================================================================
    {
      id: "m2-u3-set1",
      title: "Set 1: Question Words",
      questions: [
        {
          type: "match",
          q: "Match the question word to what it asks about.",
          pairs: [
            { left: "Where", right: "Donde" },
            { left: "When", right: "Cuando" },
            { left: "Who", right: "Quien" }
          ],
          a: "completed",
          successtip: "Where = lugar, When = tiempo, Who = persona! 🗺️⏰👤"
        },
        {
          type: "mc",
          q: "_____ are you? (Quien eres?)",
          options: ["What", "Who", "Where"],
          a: "Who",
          tip: "Who = people, What = things."
        },
        {
          type: "input",
          q: "Complete: '_____ is your name?' (asking for information)",
          a: "What",
          accept: { ignoreCase: true, ignorePunctuation: true },
          successtip: "What = qué! Perfect for asking for information! ✅"
        },
        {
          type: "match",
          q: "Match the question word to its meaning.",
          pairs: [
            { left: "Why", right: "Reason" },
            { left: "How", right: "Manner / Way" },
            { left: "What", right: "Thing / Information" }
          ],
          a: "completed",
          tip: "Why = razón, How = manera, What = cosa/información."
        },
        {
          type: "order",
          q: "Order the words to make a question.",
          words: ["Where", "is", "the", "bank?"],
          a: "Where is the bank?",
          tip: "Where + is + place."
        },
        {
          type: "mc",
          q: "To ask about TIME, we use:",
          options: ["When", "Where", "Who"],
          a: "When",
          successtip: "When = cuándo! For time and dates! ⏰"
        },
        {
          type: "input",
          q: "Complete: '_____ is that woman?' (asking about a person)",
          a: "Who",
          accept: { ignoreCase: true, ignorePunctuation: true },
          tip: "Who = quién (person)."
        },
        {
          type: "match",
          q: "Match the question to its focus.",
          pairs: [
            { left: "How old", right: "Age" },
            { left: "What time", right: "Specific time" },
            { left: "How many", right: "Quantity" }
          ],
          a: "completed",
          successtip: "How + adjective/adverb creates specific questions! 🎯"
        },
        {
          type: "mc",
          q: "To ask for a REASON (why something happens), we use:",
          options: ["Why", "What", "Where"],
          a: "Why",
          tip: "Why = por qué (reason)."
        },
        {
          type: "order",
          q: "Order the question words.",
          words: ["When", "is", "your", "birthday?"],
          a: "When is your birthday?",
          tip: "When + is + event/time."
        }
      ]
    },

    // ===================================================================
    // SET 2: WHAT QUESTIONS (A1+)
    // ===================================================================
    {
      id: "m2-u3-set2",
      title: "Set 2: What Questions",
      questions: [
        {
          type: "mc",
          q: "'_____ is your name?' 'My name is Ana.'",
          options: ["What", "Who", "Where"],
          a: "What",
          tip: "What = qué (for information)."
        },
        {
          type: "order",
          q: "Order the words.",
          words: ["What", "do", "you", "do?"],
          a: "What do you do?",
          successtip: "What do you do? = ¿A qué te dedicas? Common question! 💼"
        },
        {
          type: "input",
          q: "'_____ time is it?' 'It's 3 o'clock.'",
          a: "What",
          accept: { ignoreCase: true, ignorePunctuation: true },
          tip: "What time = qué hora."
        },
        {
          type: "match",
          q: "Match the question to the answer.",
          pairs: [
            { left: "What is this?", right: "It's a book." },
            { left: "What do you eat?", right: "I eat pizza." },
            { left: "What time is it?", right: "It's 5pm." }
          ],
          a: "completed",
          successtip: "What can ask about things, actions, and time! Versatile! 🌟"
        },
        {
          type: "mc",
          q: "'_____ is your favorite color?'",
          options: ["What", "Who", "When"],
          a: "What"
        },
        {
          type: "order",
          q: "Order the words.",
          words: ["What", "is", "your", "job?"],
          a: "What is your job?",
          tip: "What is = qué es."
        },
        {
          type: "input",
          q: "'_____ do you want?' 'I want coffee.'",
          a: "What",
          accept: { ignoreCase: true, ignorePunctuation: true }
        },
        {
          type: "mc",
          q: "To ask about someone's occupation: 'What _____?'",
          options: ["do you do", "are you do", "is you do"],
          a: "do you do",
          successtip: "First 'do' = auxiliary, second 'do' = verb! Grammar magic! ✨"
        },
        {
          type: "order",
          q: "Order the words.",
          words: ["What", "is", "this?"],
          a: "What is this?",
          tip: "What is this = qué es esto."
        },
        {
          type: "input",
          q: "'_____ kind of music do you like?'",
          a: "What",
          accept: { ignoreCase: true, ignorePunctuation: true },
          tip: "What kind of = qué tipo de."
        }
      ]
    },

    // ===================================================================
    // SET 3: WHERE QUESTIONS (A1+)
    // ===================================================================
    {
      id: "m2-u3-set3",
      title: "Set 3: Where Questions",
      questions: [
        {
          type: "mc",
          q: "'_____ is the bathroom?' 'It's over there.'",
          options: ["Where", "What", "When"],
          a: "Where",
          tip: "Where = dónde (location)."
        },
        {
          type: "order",
          q: "Order the words.",
          words: ["Where", "do", "you", "live?"],
          a: "Where do you live?",
          successtip: "Where do you live? Super common question! 🏠"
        },
        {
          type: "input",
          q: "'_____ are you from?' 'I'm from Mexico.'",
          a: "Where",
          accept: { ignoreCase: true, ignorePunctuation: true },
          tip: "Where are you from = de dónde eres."
        },
        {
          type: "match",
          q: "Match the question to the answer.",
          pairs: [
            { left: "Where is the bank?", right: "On Main Street." },
            { left: "Where do you work?", right: "At a hospital." },
            { left: "Where are you?", right: "At home." }
          ],
          a: "completed",
          successtip: "Where asks about location! Answers use: at, on, in! 📍"
        },
        {
          type: "mc",
          q: "'_____ does she live?'",
          options: ["Where", "What", "Who"],
          a: "Where"
        },
        {
          type: "order",
          q: "Order the words.",
          words: ["Where", "is", "the", "station?"],
          a: "Where is the station?",
          tip: "Where is = dónde está."
        },
        {
          type: "input",
          q: "'_____ do you go to school?'",
          a: "Where",
          accept: { ignoreCase: true, ignorePunctuation: true }
        },
        {
          type: "mc",
          q: "To ask about location: '_____ is your house?'",
          options: ["Where", "When", "Why"],
          a: "Where",
          successtip: "Where = location questions! 🗺️"
        },
        {
          type: "order",
          q: "Order the words.",
          words: ["Where", "are", "my", "keys?"],
          a: "Where are my keys?",
          tip: "Where are = dónde están."
        },
        {
          type: "input",
          q: "'_____ can I find a good restaurant?'",
          a: "Where",
          accept: { ignoreCase: true, ignorePunctuation: true },
          tip: "Where can I = dónde puedo."
        }
      ]
    },

    // ===================================================================
    // SET 4: WHEN QUESTIONS (A2)
    // ===================================================================
    {
      id: "m2-u3-set4",
      title: "Set 4: When Questions",
      questions: [
        {
          type: "mc",
          q: "'_____ is your birthday?' 'In May.'",
          options: ["When", "Where", "What"],
          a: "When",
          tip: "When = cuándo (time)."
        },
        {
          type: "order",
          q: "Order the words.",
          words: ["When", "do", "you", "start", "work?"],
          a: "When do you start work?",
          successtip: "When do you...? asks about time of actions! ⏰"
        },
        {
          type: "input",
          q: "'_____ does the movie start?'",
          a: "When",
          accept: { ignoreCase: true, ignorePunctuation: true },
          tip: "When does = cuándo (third person)."
        },
        {
          type: "match",
          q: "Match the question to the answer.",
          pairs: [
            { left: "When is the party?", right: "On Saturday." },
            { left: "When do you wake up?", right: "At 7am." },
            { left: "When is Christmas?", right: "In December." }
          ],
          a: "completed",
          successtip: "When answers use: at (time), on (day), in (month/year)! 📅"
        },
        {
          type: "mc",
          q: "'_____ does the train arrive?'",
          options: ["When", "Where", "Who"],
          a: "When"
        },
        {
          type: "order",
          q: "Order the words.",
          words: ["When", "is", "your", "vacation?"],
          a: "When is your vacation?",
          tip: "When is = cuándo es."
        },
        {
          type: "input",
          q: "'_____ do you finish work?' 'At 5pm.'",
          a: "When",
          accept: { ignoreCase: true, ignorePunctuation: true }
        },
        {
          type: "mc",
          q: "To ask about time: '_____ does the class start?'",
          options: ["When", "What", "Where"],
          a: "When",
          successtip: "When = time questions! Perfect for schedules! ⏱️"
        },
        {
          type: "order",
          q: "Order the words.",
          words: ["When", "do", "you", "go", "home?"],
          a: "When do you go home?",
          tip: "When do you = cuándo (tú)."
        },
        {
          type: "input",
          q: "'_____ is the meeting?' 'Tomorrow at 3pm.'",
          a: "When",
          accept: { ignoreCase: true, ignorePunctuation: true }
        }
      ]
    },

    // ===================================================================
    // SET 5: WHO QUESTIONS (A2)
    // ===================================================================
    {
      id: "m2-u3-set5",
      title: "Set 5: Who Questions",
      questions: [
        {
          type: "mc",
          q: "'_____ is that man?' 'He's my teacher.'",
          options: ["Who", "What", "Where"],
          a: "Who",
          tip: "Who = quién (person)."
        },
        {
          type: "order",
          q: "Order the words.",
          words: ["Who", "is", "your", "best", "friend?"],
          a: "Who is your best friend?",
          successtip: "Who asks about people! Identity questions! 👤"
        },
        {
          type: "input",
          q: "'_____ are you?' 'I'm María.'",
          a: "Who",
          accept: { ignoreCase: true, ignorePunctuation: true },
          tip: "Who are you = quién eres."
        },
        {
          type: "match",
          q: "Match the question to the answer.",
          pairs: [
            { left: "Who is she?", right: "My sister." },
            { left: "Who teaches English?", right: "Mr. Smith." },
            { left: "Who are they?", right: "My friends." }
          ],
          a: "completed",
          successtip: "Who = people! Answers are names or relationships! 👥"
        },
        {
          type: "mc",
          q: "'_____ do you live with?'",
          options: ["Who", "Where", "When"],
          a: "Who"
        },
        {
          type: "order",
          q: "Order the words.",
          words: ["Who", "is", "calling?"],
          a: "Who is calling?",
          tip: "Who is = quién es/está."
        },
        {
          type: "input",
          q: "'_____ did you see?' 'I saw John.'",
          a: "Who",
          accept: { ignoreCase: true, ignorePunctuation: true }
        },
        {
          type: "mc",
          q: "To ask about a person: '_____ is that woman?'",
          options: ["Who", "What", "When"],
          a: "Who",
          successtip: "Who = person questions! 🧑"
        },
        {
          type: "order",
          q: "Order the words.",
          words: ["Who", "do", "you", "work", "with?"],
          a: "Who do you work with?",
          tip: "Who do you = con quién (tú)."
        },
        {
          type: "input",
          q: "'_____ wants coffee?' 'I do!'",
          a: "Who",
          accept: { ignoreCase: true, ignorePunctuation: true },
          tip: "Who wants = quién quiere."
        }
      ]
    },

    // ===================================================================
    // SET 6: WHY & HOW QUESTIONS (A2+)
    // ===================================================================
    {
      id: "m2-u3-set6",
      title: "Set 6: Why & How Questions",
      questions: [
        {
          type: "mc",
          q: "'_____ are you sad?' 'Because I'm tired.'",
          options: ["Why", "What", "When"],
          a: "Why",
          tip: "Why = por qué (reason)."
        },
        {
          type: "order",
          q: "Order the words.",
          words: ["How", "are", "you?"],
          a: "How are you?",
          successtip: "How are you? = ¿Cómo estás? Most common greeting! 👋"
        },
        {
          type: "input",
          q: "'_____ do you go to work?' 'By bus.'",
          a: "How",
          accept: { ignoreCase: true, ignorePunctuation: true },
          tip: "How = cómo (manner/method)."
        },
        {
          type: "match",
          q: "Match the question to the answer.",
          pairs: [
            { left: "Why are you happy?", right: "Because it's my birthday!" },
            { left: "How do you get here?", right: "I walk." },
            { left: "How old are you?", right: "I'm 25." }
          ],
          a: "completed",
          successtip: "Why needs 'because' in answer! How asks for method or state! 🎯"
        },
        {
          type: "mc",
          q: "'_____ is he late?' 'Because of traffic.'",
          options: ["Why", "How", "Where"],
          a: "Why"
        },
        {
          type: "order",
          q: "Order the words.",
          words: ["How", "do", "you", "spell", "that?"],
          a: "How do you spell that?",
          tip: "How do you = cómo (tú)."
        },
        {
          type: "input",
          q: "'_____ old is your sister?'",
          a: "How",
          accept: { ignoreCase: true, ignorePunctuation: true },
          successtip: "How old = qué edad! How + adjective = specific questions! 🎂"
        },
        {
          type: "mc",
          q: "To ask for a reason: '_____ don't you like pizza?'",
          options: ["Why", "What", "Where"],
          a: "Why",
          tip: "Why = reason questions."
        },
        {
          type: "order",
          q: "Order the words.",
          words: ["How", "much", "is", "this?"],
          a: "How much is this?",
          tip: "How much = cuánto cuesta."
        },
        {
          type: "input",
          q: "'_____ many students are there?'",
          a: "How",
          accept: { ignoreCase: true, ignorePunctuation: true },
          tip: "How many = cuántos."
        }
      ]
    },

    // ===================================================================
    // SET 7: MIXED WH- QUESTIONS (A2+)
    // ===================================================================
    {
      id: "m2-u3-set7",
      title: "Set 7: Mixed Questions",
      questions: [
        {
          type: "match",
          q: "Match the question word to the sentence.",
          pairs: [
            { left: "What", right: "_____ is your phone number?" },
            { left: "Where", right: "_____ is the library?" },
            { left: "When", right: "_____ do you have lunch?" }
          ],
          a: "completed",
          successtip: "What=info, Where=place, When=time! Master these 3! 🎯"
        },
        {
          type: "mc",
          q: "'_____ is your favorite food?'",
          options: ["What", "Who", "Where"],
          a: "What",
          tip: "Favorite food = thing, not person."
        },
        {
          type: "order",
          q: "Order the words.",
          words: ["Where", "do", "you", "buy", "your", "clothes?"],
          a: "Where do you buy your clothes?",
          tip: "Where do you = dónde (tú)."
        },
        {
          type: "input",
          q: "'_____ does the store close?'",
          a: "When",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["What time"] }
        },
        {
          type: "mc",
          q: "'_____ do you do in your free time?'",
          options: ["What", "When", "Where"],
          a: "What",
          successtip: "What do you do? = ¿Qué haces? Activities! 🎨"
        },
        {
          type: "order",
          q: "Order the words.",
          words: ["Who", "is", "your", "favorite", "actor?"],
          a: "Who is your favorite actor?",
          tip: "Actor = person → Who."
        },
        {
          type: "input",
          q: "'_____ are you late?' 'Because I missed the bus.'",
          a: "Why",
          accept: { ignoreCase: true, ignorePunctuation: true },
          tip: "Because in answer → Why in question."
        },
        {
          type: "mc",
          q: "'_____ do you get to school?'",
          options: ["How", "What", "Who"],
          a: "How",
          tip: "How = method of transportation."
        },
        {
          type: "order",
          q: "Order the words.",
          words: ["What", "time", "do", "you", "wake", "up?"],
          a: "What time do you wake up?",
          tip: "What time = qué hora."
        },
        {
          type: "input",
          q: "'_____ does this word mean?'",
          a: "What",
          accept: { ignoreCase: true, ignorePunctuation: true },
          successtip: "What does...mean? Super useful for learning! 📚"
        }
      ]
    },

    // ===================================================================
    // SET 8: QUESTION FORMATION (B1-)
    // ===================================================================
    {
      id: "m2-u3-set8",
      title: "Set 8: Building Questions",
      questions: [
        {
          type: "order",
          q: "Order the question.",
          words: ["What", "do", "you", "do", "for", "a", "living?"],
          a: "What do you do for a living?",
          successtip: "For a living = profession! Native expression! 💼"
        },
        {
          type: "mc",
          q: "Correct question: 'Where _____?'",
          options: ["do you live", "you live", "live you"],
          a: "do you live",
          tip: "Wh- word + do/does + subject + verb."
        },
        {
          type: "input",
          q: "Complete: '_____ often do you exercise?'",
          a: "How",
          accept: { ignoreCase: true, ignorePunctuation: true },
          tip: "How often = con qué frecuencia."
        },
        {
          type: "order",
          q: "Order the words.",
          words: ["Why", "don't", "you", "like", "coffee?"],
          a: "Why don't you like coffee?",
          tip: "Why + don't/doesn't for negative questions."
        },
        {
          type: "match",
          q: "Match the error to the correction.",
          pairs: [
            { left: "Where you live?", right: "Where DO you live?" },
            { left: "What time is start?", right: "What time DOES it start?" },
            { left: "Who is that girl?", right: "CORRECT!" }
          ],
          a: "completed",
          successtip: "Don't forget the auxiliary DO/DOES! Common mistake! ⚠️"
        },
        {
          type: "mc",
          q: "'_____ is your car?' 'The blue one.'",
          options: ["Which", "What", "Who"],
          a: "Which",
          tip: "Which = cuál (choosing from options)."
        },
        {
          type: "order",
          q: "Order the words.",
          words: ["How", "long", "does", "it", "take?"],
          a: "How long does it take?",
          successtip: "How long = cuánto tiempo! Duration questions! ⏱️"
        },
        {
          type: "input",
          q: "'_____ far is the airport?'",
          a: "How",
          accept: { ignoreCase: true, ignorePunctuation: true },
          tip: "How far = qué tan lejos (distance)."
        },
        {
          type: "mc",
          q: "Correct: '_____ did you go yesterday?'",
          options: ["Where", "What", "Who"],
          a: "Where",
          tip: "Past tense still uses same Wh- words."
        },
        {
          type: "order",
          q: "Order the words.",
          words: ["Whose", "book", "is", "this?"],
          a: "Whose book is this?",
          tip: "Whose = de quién (possession)."
        }
      ]
    },

    // ===================================================================
    // SET 9: REAL-LIFE QUESTIONS (B1-)
    // ===================================================================
    {
      id: "m2-u3-set9",
      title: "Set 9: Real Conversations",
      questions: [
        {
          type: "match",
          q: "Match common questions to situations.",
          pairs: [
            { left: "Where is the restroom?", right: "At a restaurant" },
            { left: "How much is this?", right: "At a store" },
            { left: "What time is it?", right: "Asking for time" }
          ],
          a: "completed",
          successtip: "These are SURVIVAL questions! Memorize them! 🆘"
        },
        {
          type: "mc",
          q: "Polite way to ask someone's name:",
          options: ["What's your name?", "Who you?", "What you name?"],
          a: "What's your name?",
          tip: "What's = What is (contraction)."
        },
        {
          type: "order",
          q: "Order the question.",
          words: ["Where", "can", "I", "buy", "tickets?"],
          a: "Where can I buy tickets?",
          tip: "Where can I = dónde puedo."
        },
        {
          type: "input",
          q: "At airport: '_____ is my gate?'",
          a: "Where",
          accept: { ignoreCase: true, ignorePunctuation: true },
          successtip: "Where is my gate? Essential travel question! ✈️"
        },
        {
          type: "mc",
          q: "Meeting someone: '_____ do you do?'",
          options: ["What", "Where", "Who"],
          a: "What",
          tip: "What do you do = profession."
        },
        {
          type: "order",
          q: "Order the question.",
          words: ["How", "can", "I", "help", "you?"],
          a: "How can I help you?",
          tip: "Customer service phrase."
        },
        {
          type: "input",
          q: "Lost person: '_____ am I?'",
          a: "Where",
          accept: { ignoreCase: true, ignorePunctuation: true },
          successtip: "Where am I? = ¿Dónde estoy? When you're lost! 🗺️"
        },
        {
          type: "mc",
          q: "Shopping: '_____ does this cost?'",
          options: ["How much", "How many", "What many"],
          a: "How much",
          tip: "How much = cuánto cuesta."
        },
        {
          type: "order",
          q: "Order the question.",
          words: ["Why", "are", "you", "here?"],
          a: "Why are you here?",
          tip: "Why are you = por qué estás."
        },
        {
          type: "input",
          q: "Doctor visit: '_____ do you feel?'",
          a: "How",
          accept: { ignoreCase: true, ignorePunctuation: true },
          tip: "How do you feel = cómo te sientes."
        }
      ]
    },

    // ===================================================================
    // SET 10: ADVANCED QUESTIONS (B1-)
    // ===================================================================
    {
      id: "m2-u3-set10",
      title: "Set 10: Question Masters",
      questions: [
        {
          type: "match",
          q: "Match advanced question forms.",
          pairs: [
            { left: "How come?", right: "Why? (informal)" },
            { left: "What for?", right: "For what purpose?" },
            { left: "How so?", right: "In what way?" }
          ],
          a: "completed",
          successtip: "Native shortcuts! How come = Why (casual)! 😎"
        },
        {
          type: "order",
          q: "Order the question.",
          words: ["What", "kind", "of", "music", "do", "you", "like?"],
          a: "What kind of music do you like?",
          tip: "What kind of = qué tipo de."
        },
        {
          type: "mc",
          q: "'_____ else wants coffee?' (asking about other people)",
          options: ["Who", "What", "Where"],
          a: "Who",
          successtip: "Who else? = ¿Quién más? Add 'else' for 'other'! ➕"
        },
        {
          type: "input",
          q: "'_____ did you say?' (asking to repeat)",
          a: "What",
          accept: { ignoreCase: true, ignorePunctuation: true },
          tip: "What did you say = qué dijiste."
        },
        {
          type: "order",
          q: "Order the question.",
          words: ["How", "about", "we", "go", "home?"],
          a: "How about we go home?",
          tip: "How about = qué tal si (suggestion)."
        },
        {
          type: "mc",
          q: "Asking opinion: '_____ do you think?'",
          options: ["What", "How", "Why"],
          a: "What",
          successtip: "What do you think? = ¿Qué piensas? Opinion question! 💭"
        },
        {
          type: "input",
          q: "'_____ were you born?' 'In 1995.'",
          a: "When",
          accept: { ignoreCase: true, ignorePunctuation: true },
          tip: "When were you born = cuándo naciste."
        },
        {
          type: "order",
          q: "Order the question.",
          words: ["Which", "one", "do", "you", "prefer?"],
          a: "Which one do you prefer?",
          tip: "Which = cuál (from specific options)."
        },
        {
          type: "mc",
          q: "Final question! The MOST important word in this unit:",
          options: ["Questions help you learn!", "I don't know", "Skip this"],
          a: "Questions help you learn!",
          successtip: "Perfect! Asking questions is HOW you learn! Keep asking! 🚀"
        },
        {
          type: "input",
          q: "Last one! Your favorite question word:",
          a: "What",
          accept: { ignoreCase: true, ignorePunctuation: true, alts: ["Where", "When", "Who", "Why", "How", "Which", "Whose"] },
          tip: "Any answer is correct!",
          successtip: "Excellent work! You've mastered WH- questions! Unit 3 complete! 🎉"
        }
      ]
    }
  ],

  // ===================================================================
  // REVIEW SET (10 questions)
  // ===================================================================
  reviewSet: {
    id: "m2-u3-review",
    title: "Unit 3 Review",
    questions: [
      {
        type: "match",
        q: "Review: Match question words.",
        pairs: [
          { left: "What", right: "Thing/Info" },
          { left: "Where", right: "Place" },
          { left: "When", right: "Time" }
        ],
        a: "completed",
        successtip: "Perfect review! The big 3! 🌟"
      },
      {
        type: "input",
        q: "Review: '_____ is your name?'",
        a: "What",
        accept: { ignoreCase: true, ignorePunctuation: true }
      },
      {
        type: "mc",
        q: "Review: '_____ do you live?'",
        options: ["Where", "What", "Who"],
        a: "Where",
        tip: "Live = location → Where."
      },
      {
        type: "order",
        q: "Review: Order the question.",
        words: ["When", "is", "your", "birthday?"],
        a: "When is your birthday?",
        tip: "When = time."
      },
      {
        type: "input",
        q: "Review: '_____ is that woman?'",
        a: "Who",
        accept: { ignoreCase: true, ignorePunctuation: true },
        tip: "Woman = person → Who."
      },
      {
        type: "mc",
        q: "Review: '_____ are you sad?'",
        options: ["Why", "What", "Where"],
        a: "Why",
        tip: "Why = reason."
      },
      {
        type: "order",
        q: "Review: Order the question.",
        words: ["How", "are", "you?"],
        a: "How are you?",
        successtip: "Classic greeting! 👋"
      },
      {
        type: "input",
        q: "Review: '_____ time is it?'",
        a: "What",
        accept: { ignoreCase: true, ignorePunctuation: true },
        tip: "What time = qué hora."
      },
      {
        type: "mc",
        q: "Review: '_____ do you go to work?'",
        options: ["How", "What", "Who"],
        a: "How",
        tip: "How = method/manner."
      },
      {
        type: "order",
        q: "Review: Final question!",
        words: ["What", "do", "you", "do?"],
        a: "What do you do?",
        successtip: "Excellent! Review complete! Ready for reading! 📖"
      }
    ]
  },

  // ===================================================================
  // READING SET (10 questions based on passage)
  // ===================================================================
  readingSet: {
    id: "m2-u3-reading",
    title: "Reading: Interview with Ana",
    passage: `
**AN INTERVIEW WITH ANA GARCIA**

Reporter: Hi Ana! Thanks for talking with us today.

Ana: You're welcome!

Reporter: So, what do you do?

Ana: I'm a doctor. I work at City Hospital.

Reporter: Interesting! Where is City Hospital?

Ana: It's on Main Street, near the park.

Reporter: When do you start work?

Ana: I usually start at 7am. It's very early!

Reporter: Wow! How do you get to work?

Ana: I drive my car. It takes 20 minutes.

Reporter: Who do you work with?

Ana: I work with many nurses and other doctors. My best friend Maria is a nurse there.

Reporter: Why did you become a doctor?

Ana: Because I love helping people. It's my passion!

Reporter: What do you do in your free time?

Ana: I like reading books and going to the gym.

Reporter: When is your birthday?

Ana: It's on May 15th. I'm turning 32 this year!

Reporter: Thank you, Ana!

Ana: Thank you!
    `,
    questions: [
      {
        type: "mc",
        q: "What does Ana do?",
        options: ["She's a doctor", "She's a nurse", "She's a teacher"],
        a: "She's a doctor",
        tip: "First question: 'What do you do?'"
      },
      {
        type: "input",
        q: "Where does Ana work? (Type 2 words)",
        a: "City Hospital",
        accept: { ignoreCase: true, ignorePunctuation: true, alts: ["city hospital"] },
        tip: "The passage says 'I work at...'"
      },
      {
        type: "mc",
        q: "Where is City Hospital?",
        options: ["On Main Street", "On Park Avenue", "On First Street"],
        a: "On Main Street",
        successtip: "On Main Street, near the park! 📍"
      },
      {
        type: "input",
        q: "When does Ana start work?",
        a: "7am",
        accept: { ignoreCase: true, ignorePunctuation: true, alts: ["7 am", "seven am", "at 7am"] },
        tip: "Look for 'I usually start at...'"
      },
      {
        type: "mc",
        q: "How does Ana get to work?",
        options: ["She drives", "She takes the bus", "She walks"],
        a: "She drives",
        tip: "She says 'I drive my car.'"
      },
      {
        type: "input",
        q: "Who is Maria?",
        a: "nurse",
        accept: { ignoreCase: true, ignorePunctuation: true, alts: ["a nurse", "her friend", "Ana's friend"] },
        successtip: "Maria is Ana's best friend and a nurse! 👩‍⚕️"
      },
      {
        type: "mc",
        q: "Why did Ana become a doctor?",
        options: ["She loves helping people", "It pays well", "Her parents are doctors"],
        a: "She loves helping people",
        tip: "'Because I love helping people.'"
      },
      {
        type: "input",
        q: "What does Ana like doing in her free time? (Name one activity - 1 word)",
        a: "reading",
        accept: { ignoreCase: true, ignorePunctuation: true, alts: ["gym", "books"] },
        tip: "She says two things: reading and gym."
      },
      {
        type: "mc",
        q: "When is Ana's birthday?",
        options: ["May 15th", "May 5th", "March 15th"],
        a: "May 15th",
        successtip: "May 15th! She's turning 32! 🎂"
      },
      {
        type: "mc",
        q: "How old will Ana be this year?",
        options: ["32", "31", "30"],
        a: "32",
        tip: "'I'm turning 32 this year.'",
        successtip: "Perfect! Unit 3 complete! You're a question master! 🏆"
      }
    ]
  }
};
